import api from '../../services/api';
import { OPERATOR_REQUEST_CONFIG, warehousePath } from '../operator/operatorApi';

/** Orders to pick: entered, reserved or already being picked. */
export const getPickingOrdersRequest = (warehouseId, { page = 1 } = {}) =>
  api.get(warehousePath(warehouseId, 'picking/orders/'), { ...OPERATOR_REQUEST_CONFIG, params: { page } });

/** An order with its lines in route order, each with where to take it from. */
export const getPickingOrderRequest = (warehouseId, orderId) =>
  api.get(warehousePath(warehouseId, `picking/orders/${orderId}/`), OPERATOR_REQUEST_CONFIG);

/** `{product_code, slot_code, quantity, line_id?, lot?, idempotency_key}` */
export const pickRequest = (warehouseId, orderId, body) =>
  api.post(warehousePath(warehouseId, `picking/orders/${orderId}/pick/`), body, OPERATOR_REQUEST_CONFIG);

/** `{line_id, slot_code, quantity, lot?, reason?, idempotency_key}`: puts picked units back in a slot. */
export const unpickRequest = (warehouseId, orderId, body) =>
  api.post(warehousePath(warehouseId, `picking/orders/${orderId}/unpick/`), body, OPERATOR_REQUEST_CONFIG);

/** `{line_id, slot_code, found_quantity, reason, product_code?, lot?, notes?, idempotency_key}` */
export const shortPickRequest = (warehouseId, orderId, body) =>
  api.post(warehousePath(warehouseId, `picking/orders/${orderId}/short-pick/`), body, OPERATOR_REQUEST_CONFIG);

/**
 * `{idempotency_key}`: reserves what the order still lacks, as far as there is
 * free stock → `{reserved_now, lines_complete, lines_total, order}`. Sent again,
 * it reserves nothing twice.
 */
export const reservePickingOrderRequest = (warehouseId, orderId, body) =>
  api.post(warehousePath(warehouseId, `picking/orders/${orderId}/reserve/`), body, OPERATOR_REQUEST_CONFIG);

/*
 * Picking by route (contract proposed to ninja-back): one walk for one order
 * or a batch of up to ten, stop by stop. Every write answers the route
 * recalculated.
 */

/**
 * The route of some orders: `{orders, skipped, stops, unplannable}`, the stops
 * in walking order.
 *
 * @param {number|string} warehouseId
 * @param {number[]} orderIds - Ten at most.
 */
export const getPickingRouteRequest = (warehouseId, orderIds) =>
  api.get(warehousePath(warehouseId, 'picking/route/'), {
    ...OPERATOR_REQUEST_CONFIG,
    params: { orders: orderIds.join(',') },
  });

/**
 * `{slot_code, product_code, quantity, lot?, order_ids, idempotency_key}`: the
 * server splits it among the orders → `{replayed, pick_key, applied, route}`.
 */
export const routePickRequest = (warehouseId, body) =>
  api.post(warehousePath(warehouseId, 'picking/route/pick/'), body, OPERATOR_REQUEST_CONFIG);

/**
 * `{slot_code, product_id, lot?, found_quantity, reason, notes?, order_ids,
 * idempotency_key}`: picks what was found and leaves the shortage → `{route}`.
 */
export const routeShortRequest = (warehouseId, body) =>
  api.post(warehousePath(warehouseId, 'picking/route/short/'), body, OPERATOR_REQUEST_CONFIG);

/** `{pick_key, idempotency_key}`: gives a take back → `{route}`; 409 once it is in an item or left picking. */
export const routeUndoRequest = (warehouseId, body) =>
  api.post(warehousePath(warehouseId, 'picking/route/undo/'), body, OPERATOR_REQUEST_CONFIG);
